import { decodeVacancyState } from 'models/VacancyState';
import { ServerApi } from 'modules/api/server-api';

export const fetchCandidateVacancy = (api: ServerApi) => async (vacancyId: number) => {
  const response = await api.get(`/v3/candidate/vacancies/${vacancyId}`);
  return decodeVacancyState(response.data);
};
